"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configReducer = void 0;

var _immer = _interopRequireDefault(require("immer"));

var configReducer = function configReducer(state, action) {
  return (0, _immer.default)(state, function (draft) {
    switch (action.type) {
      default:
    }
  });
};

exports.configReducer = configReducer;